module.exports = __webpack_public_path__ + "media/images/headline-product-8869b49fde0c5d4f351fef8053e23677.svg";